<template>
  <div class="hc-dropdown-item-box" @click="handleCmd">
    <slot></slot>
  </div>
</template>

<script>
import { injectionKeyCommandHandler } from './keys'
export default {
  inject: {
    commandHandler: {
      from: injectionKeyCommandHandler,
      default() {
        return () => {
          throw new Error('组件只能在 <HcDropdown />内部使用')
        }
      }
    }
  },
  props: {
    command: {
      type: [String, Number],
      default: ''
    },
  },
  methods: {
    handleCmd() {
      this.commandHandler(this.command)
    }
  },
}
</script>

<style lang="scss" scoped>
.hc-dropdown-item-box {
  cursor: pointer;
  min-width: 80px;
  height: 32px;
  color: $main-text-color;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 18px;
  padding: 0 16px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  &:hover {
    color: $main-color;
    background-color: rgba($main-color, 0.05);
  }
}
</style>
